/**
 * Barra de compra pegada abajo.
 *
 * No tiene formulario propio. El boton lleva el atributo `form` apuntando al
 * formulario de compra de Horizon, asi que al pulsarlo dispara el mismo submit
 * que el boton de la caja: la misma variante, la misma cantidad y el mismo
 * peldano de la escalera. Un segundo formulario habria sido una segunda fuente
 * de verdad, y de ahi salen los carritos que no coinciden con lo que se vio.
 *
 * Solo aparece cuando el boton de la caja de compra sale de pantalla. Mientras
 * el original esta a la vista, dos botones iguales compiten por la misma
 * decision.
 */
class StickyBuyBar extends HTMLElement {
  #observer = null;

  connectedCallback() {
    this.#measure();
    window.addEventListener('resize', this.#measure);

    const scope = this.closest('.shopify-section') ?? document;
    const anchor = scope.querySelector('[ref="productFormButtons"], .product-form-buttons');

    if (!anchor) {
      this.dataset.state = 'visible';
      return;
    }

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        this.dataset.state = entry.isIntersecting ? 'hidden' : 'visible';
        this.#measure();
      },
      { threshold: 0 }
    );
    this.#observer.observe(anchor);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    window.removeEventListener('resize', this.#measure);
    document.documentElement.style.removeProperty('--sticky-buy-height');
  }

  #measure = () => {
    const alto = this.offsetHeight;
    if (alto > 0) document.documentElement.style.setProperty('--sticky-buy-height', `${alto}px`);
  };
}

if (!customElements.get('sticky-buy-bar')) customElements.define('sticky-buy-bar', StickyBuyBar);
